export function Vercel() {
  return <path fill="currentColor" d="m12 1l12 21H0z" />
}
